module.exports = class SmsCampaignShowCtrl
  constructor: ->
    'ngInject'
